'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
export function useSlug() {
  const $ = _c(2);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname?.split("/")?.pop();
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const slug = t0;
  return slug ?? "";
}